(function () {
  class Blog extends HTMLElement {
    constructor() {
      super();
      this.currentPage = 2;
      this.totalPages = this.dataset?.totalPages || 1;
      this.loadMoreBtn = this.querySelector("#load-more-articles");
      this.getNextArticles = this.getNextArticles.bind(this);
      this.container = this.querySelector(".blog-articles");
    }

    checkIfLastPage() {
      if (this.currentPage > this.totalPages) {
        this.loadMoreBtn.style.display = "none";
      }
    }

    renderArticles(data) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      const newContainer = doc.querySelector(".main-blog__articles");
      const newArticles = newContainer.querySelectorAll(".article");
      this.container.append(...newArticles);
    }

    async getNextArticles() {
      try {
        const response = await fetch(`?page=${this.currentPage}`);
        const data = await response.text();
        this.currentPage += 1;
        this.checkIfLastPage();
        this.renderArticles(data);
      } catch (error) {
        console.log(error);
      }
    }

    connectedCallback() {
      this.loadMoreBtn?.addEventListener("click", this.getNextArticles);
    }
    disconnectedCallback() {
      this.loadMoreBtn?.removeEventListener("click", this.getNextArticles);
    }
  }
  if (!customElements.get("blog-element")) {
    customElements.define("blog-element", Blog);
  }
})();
